/**
 * slug.ts — the client's entry point to the one slug derivation in the repo.
 *
 * Repo convention: `name` is the human-readable label, `slug` is the kebab-case system
 * identifier. The derivation itself lives in `@confluent/shared/lib/slug` so that a slug the
 * client previews is byte-identical to the one the server would mint for the same name — the
 * private copy that used to live here truncated at 60 and could return `''`, and neither
 * matched the server.
 */
import { slugify } from '@confluent/shared/lib/slug';

/**
 * `organizations.slug`, `projects.slug` and `teams.slug` are all `varchar(100)` — the three
 * columns every client-side slug preview feeds.
 */
export const ENTITY_SLUG_MAX_LENGTH = 100;

/** Derive the kebab-case slug the server will store for `name`. */
export function toSlug(name: string): string {
  return slugify(name, { maxLength: ENTITY_SLUG_MAX_LENGTH });
}
